export enum ImportExistingContactType {
    Undefined = 0,
    Ignore = 1,
    Update = 2
}
